import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

interface IProps {
  text?: string;
}

export const Feedback = ({ text }: IProps) => {
  const t = useTranslations();

  return (
    <Link
      target="_blank"
      href={`${process.env.NEXT_PUBLIC_AKAM_ADMIN}`}
      className="lg:mb-1 lg:mr-3 flex items-center gap-2 rounded-lg bg-yellow-100 px-2 py-1.5 text-sm font-medium text-gray-700 lg:py-1"
      aria-label="Akam Admin large screen link"
    >
      <div className="lg:h-4.5 lg:w-4.5 relative h-5 w-5">
        <Image fill src="/images/warning.webp" alt="warning" title="Warning" />
      </div>
      <span className="hidden lg:block">{text || t('xatolar_va_takliflar')}</span>
    </Link>
  );
};
